import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import axios from '../../axios.js';

import '../Resources/dashboard.css';
import Navbar from './navbar.js';
import Sidebar from './sidebar.js';
//import Newcrm_createteam from './newcrm_createteam.js';
import moment from 'moment/moment';
//import Create_customer from '../create_customer';

import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';

//EXCEL DOWNLOAD IMPORT
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Newcrm_addcustomer from './newcrm_addcustomer.js';
import Newcrm_createlead from './newcrm_createlead.js';



function Newcrm_receipts(){

  
      //Report Print Function
      const componentRef = useref();
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });
  

    
 // Function to download the data as an Excel file
 const downloadExcel = () => {
  // Convert JSON data to Excel worksheet
  const worksheet = XLSX.utils.json_to_sheet(data);
  
  // Create a new workbook and add the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
  // Convert the workbook to a binary array
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  
  // Create a Blob from the binary data and trigger a download
  const excel_data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(excel_data, "data.xlsx");
};



  //console.log
  
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");



{/* CUSTOMERS TABLE COLUMNS MANAGEMENT VARIABLES START */}
const[cd_col1_val,setcd_col1_val] = useState(0);//column1
const[cd_col2_val,setcd_col2_val] = useState(0);//column2
const[cd_col3_val,setcd_col3_val] = useState(0);//column3
const[cd_col4_val,setcd_col4_val] = useState(0);//column4
const[cd_col5_val,setcd_col5_val] = useState(0);//column5
const[cd_col6_val,setcd_col6_val] = useState(0);//column6
const[cd_col7_val,setcd_col7_val] = useState(0);//column7
const[cd_col8_val,setcd_col8_val] = useState(0);//column8
const[cd_col9_val,setcd_col9_val] = useState(0);//column9
const[cd_col10_val,setcd_col10_val] = useState(0);//column10
const[cd_col11_val,setcd_col11_val] = useState(0);//column11
const[cd_col12_val,setcd_col12_val] = useState(0);//column12
const[cd_col13_val,setcd_col13_val] = useState(0);//column13
const[cd_col14_val,setcd_col14_val] = useState(0);//column14
const[cd_col15_val,setcd_col15_val] = useState(0);//column15
const[cd_col16_val,setcd_col16_val] = useState(0);//column16
const[cd_col17_val,setcd_col17_val] = useState(0);//column17
const[cd_col18_val,setcd_col18_val] = useState(0);//column18

//Variables
const[data,setData] = useState([]);//SetData Variable

//Error Variable
const[errorvar,seterrorvar] = useState();


//FILTER VARIABLES
const[filter_val,setfilter_val] = useState(0);


const[filter_receipt_number,setfilter_receipt_number] = useState(); const updatefilter_receipt_number = (event) => { setfilter_receipt_number(event.target.value);}; const[filter_receipt_number_er,setfilter_receipt_number_er]=useState();
const[filter_customer_name,setfilter_customer_name] = useState(); const updatefilter_customer_name = (event) => { setfilter_customer_name(event.target.value);}; const[filter_customer_name_er,setfilter_customer_name_er]=useState();
const[filter_receipt_date,setfilter_receipt_date] = useState('1970-01-01'); const updatefilter_receipt_date = (event) => { setfilter_receipt_date(event.target.value);}; const[filter_receipt_date_er,setfilter_receipt_date_er]=useState();
const[filter_email,setfilter_email] = useState(); const updatefilter_email = (event) => { setfilter_email(event.target.value);}; const[filter_email_er,setfilter_email_er]=useState();
const[filter_contact,setfilter_contact] = useState(); const updatefilter_contact = (event) => { setfilter_contact(event.target.value);}; const[filter_contact_er,setfilter_contact_er]=useState();
const[filter_payment_status,setfilter_payment_status] = useState(); const updatefilter_payment_status = (event) => { setfilter_payment_status(event.target.value);}; const[filter_payment_status_er,setfilter_payment_status_er]=useState();
const[filter_amount_paid,setfilter_amount_paid] = useState(); const updatefilter_amount_paid = (event) => { setfilter_amount_paid(event.target.value);}; const[filter_amount_paid_er,setfilter_amount_paid_er]=useState();
const[filter_payment_mode,setfilter_payment_mode] = useState(); const updatefilter_payment_mode = (event) => { setfilter_payment_mode(event.target.value);}; const[filter_payment_mode_er,setfilter_payment_mode_er]=useState();
const[filter_transaction_id,setfilter_transaction_id] = useState(); const updatefilter_transaction_id = (event) => { setfilter_transaction_id(event.target.value);}; const[filter_transaction_id_er,setfilter_transaction_id_er]=useState();
const[filter_remarks,setfilter_remarks] = useState(); const updatefilter_remarks = (event) => { setfilter_remarks(event.target.value);}; const[filter_remarks_er,setfilter_remarks_er]=useState();
const[filter_receipt_head,setfilter_receipt_head] = useState(); const updatefilter_receipt_head = (event) => { setfilter_receipt_head(event.target.value);}; const[filter_receipt_head_er,setfilter_receipt_head_er]=useState();


//Variables for pagination
const [currentPage, setCurrentPage] = useState(1);
const [pageNumber, setpageNumber] = useState(1);

useEffect(()=>{
   
  getData();
  
  },[])
 
  
 
    
//******************* GET CUSTOMERS DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
    const $filter_receipt_number = filter_receipt_number; const $filter_customer_name = filter_customer_name; const $filter_receipt_date = filter_receipt_date; const $filter_email = filter_email; const $filter_contact = filter_contact; const $filter_payment_status = filter_payment_status; 
    const $filter_amount_paid = filter_amount_paid; const $filter_payment_mode = filter_payment_mode; const $filter_transaction_id = filter_transaction_id; const $filter_remarks = filter_remarks; const $filter_receipt_head = filter_receipt_head;
 
 axios.post("newcrm-get-receipts-list", {
   Log_id:logid,
   Token:token,
 //  Busy_id:busyid,
 //  Counter_id:counterid,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
   Filter_val : filter_val,
   Filter_receipt_number : $filter_receipt_number,
   Filter_customer_name : $filter_customer_name,
   Filter_receipt_date : $filter_receipt_date,
   Filter_email : $filter_email,
   Filter_contact : $filter_contact,
   Filter_payment_status : $filter_payment_status,
   Filter_amount_paid : $filter_amount_paid,
   Filter_payment_mode : $filter_payment_mode,
   Filter_transaction_id : $filter_transaction_id,
   Filter_remarks : $filter_remarks,
   Filter_receipt_head : $filter_receipt_head,
   
   //Code Edits for pagination
   'page' : pageNumber


   })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");

     window.location.replace("/");
  }
  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   setData(response.data.data.data);
  
  }

  //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){
    setfilter_receipt_number_er(response.data.validatorerror.Filter_receipt_number);
    setfilter_customer_name_er(response.data.validatorerror.Filter_customer_name);
    setfilter_receipt_date_er(response.data.validatorerror.Filter_receipt_date);
    setfilter_email_er(response.data.validatorerror.Filter_email);
    setfilter_contact_er(response.data.validatorerror.Filter_contact);
    setfilter_payment_status_er(response.data.validatorerror.Filter_payment_status);
    setfilter_amount_paid_er(response.data.validatorerror.Filter_amount_paid);
    setfilter_payment_mode_er(response.data.validatorerror.Filter_payment_mode);
    setfilter_transaction_id_er(response.data.validatorerror.Filter_transaction_id);
    setfilter_remarks_er(response.data.validatorerror.Filter_remarks);
    setfilter_receipt_head_er(response.data.validatorerror.Filter_receipt_head);

  }

  //Data Violation
  if(response.data.error==102){ 
  
    setfilter_receipt_number_er(response.data.filter_receipt_number_er);
    setfilter_customer_name_er(response.data.filter_customer_name_er);
    setfilter_receipt_date_er(response.data.filter_receipt_date_er);
    setfilter_email_er(response.data.filter_email_er);
    setfilter_contact_er(response.data.filter_contact_er);
    setfilter_payment_status_er(response.data.filter_payment_status_er);
    setfilter_amount_paid_er(response.data.filter_amount_paid_er);
    setfilter_payment_mode_er(response.data.filter_payment_mode_er);
    setfilter_transaction_id_er(response.data.filter_transaction_id_er);
    setfilter_remarks_er(response.data.filter_remarks_er);
    setfilter_receipt_head_er(response.data.filter_receipt_head_er);

  }


  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");


   window.location.replace("/");
 
  }
 
 }
  
 //******************* GET CUSTOMERS DATA FUNCTION END  ********************//


 

//ERROR VARIABLES 
const[eerror_msg,seteerror_msg]=useState();
 



//receipt_number
const[receipt_number,setreceipt_number]=useState();const updatereceipt_number = (event) => { setreceipt_number(event.target.value);}; const[receipt_number_er,setreceipt_number_er]=useState();
//receipt_date
const[receipt_date,setreceipt_date]=useState();const updatereceipt_date = (event) => { setreceipt_date(event.target.value);}; const[receipt_date_er,setreceipt_date_er]=useState();
//receipt_head
const[receipt_head,setreceipt_head]=useState();const updatereceipt_head = (event) => { setreceipt_head(event.target.value);}; const[receipt_head_er,setreceipt_head_er]=useState();
//type
const[type,settype]=useState();const updatetype = (event) => { settype(event.target.value);}; const[type_er,settype_er]=useState();
//customer_name
const[customer_name,setcustomer_name]=useState();const updatecustomer_name = (event) => { setcustomer_name(event.target.value);}; const[customer_name_er,setcustomer_name_er]=useState();
//email
const[email,setemail]=useState();const updateemail = (event) => { setemail(event.target.value);}; const[email_er,setemail_er]=useState();
//contact
const[contact,setcontact]=useState();const updatecontact = (event) => { setcontact(event.target.value);}; const[contact_er,setcontact_er]=useState();
//amount
const[amount,setamount]=useState();const updateamount = (event) => { setamount(event.target.value); calculator(); }; const[amount_er,setamount_er]=useState();
//discount_per
const[discount_per,setdiscount_per]=useState();const updatediscount_per = (event) => { setdiscount_per(event.target.value); calculator(); }; const[discount_per_er,setdiscount_per_er]=useState();
//discount_amt
const[discount_amt,setdiscount_amt]=useState();const updatediscount_amt = (event) => { setdiscount_amt(event.target.value); calculator(); }; const[discount_amt_er,setdiscount_amt_er]=useState();
//sgst_per
const[sgst_per,setsgst_per]=useState();const updatesgst_per = (event) => { setsgst_per(event.target.value); calculator(); }; const[sgst_per_er,setsgst_per_er]=useState();
//sgst_amt
const[sgst_amt,setsgst_amt]=useState();const updatesgst_amt = (event) => { setsgst_amt(event.target.value); calculator(); }; const[sgst_amt_er,setsgst_amt_er]=useState();
//cgst_per
const[cgst_per,setcgst_per]=useState();const updatecgst_per = (event) => { setcgst_per(event.target.value); calculator(); }; const[cgst_per_er,setcgst_per_er]=useState();
//cgst_amt
const[cgst_amt,setcgst_amt]=useState();const updatecgst_amt = (event) => { setcgst_amt(event.target.value); calculator(); }; const[cgst_amt_er,setcgst_amt_er]=useState();
//igst_per
const[igst_per,setigst_per]=useState();const updateigst_per = (event) => { setigst_per(event.target.value); calculator(); }; const[igst_per_er,setigst_per_er]=useState();
//igst_amt
const[igst_amt,setigst_amt]=useState();const updateigst_amt = (event) => { setigst_amt(event.target.value); calculator(); }; const[igst_amt_er,setigst_amt_er]=useState();
//payable_amount
const[payable_amount,setpayable_amount]=useState();const updatepayable_amount = (event) => { setpayable_amount(event.target.value); calculator(); }; const[payable_amount_er,setpayable_amount_er]=useState();
//amount_paid
const[amount_paid,setamount_paid]=useState();const updateamount_paid = (event) => { setamount_paid(event.target.value);}; const[amount_paid_er,setamount_paid_er]=useState();
//payment_status
const[payment_status,setpayment_status]=useState();const updatepayment_status = (event) => { setpayment_status(event.target.value);}; const[payment_status_er,setpayment_status_er]=useState();
//payment_mode
const[payment_mode,setpayment_mode]=useState();const updatepayment_mode = (event) => { setpayment_mode(event.target.value);}; const[payment_mode_er,setpayment_mode_er]=useState();
//transaction_id
const[transaction_id,settransaction_id]=useState();const updatetransaction_id = (event) => { settransaction_id(event.target.value);}; const[transaction_id_er,settransaction_id_er]=useState();
//receipt_remarks
const[receipt_remarks,setreceipt_remarks]=useState();const updatereceipt_remarks = (event) => { setreceipt_remarks(event.target.value);}; const[receipt_remarks_er,setreceipt_remarks_er]=useState();
//total
const[total,settotal]=useState();const updatetotal = (event) => { settotal(event.target.value);}; const[total_er,settotal_er]=useState();

//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();

  
    

//******************* EDIT RECEIPT FUNCTION START ********************//
function editreceipt(){

  //Setting Error Variables
setreceipt_number_er(" ");setreceipt_date_er(" ");setreceipt_head_er(" ");settype_er(" ");setcustomer_name_er(" ");setemail_er(" ");setcontact_er(" ");setamount_er(" ");setdiscount_per_er(" ");setdiscount_amt_er(" ");
setsgst_per_er(" ");setsgst_amt_er(" ");setcgst_per_er(" ");setcgst_amt_er(" ");setigst_per_er(" ");setigst_amt_er(" ");settotal_er(" ");setpayable_amount_er(" ");
setamount_paid_er(" "); setpayment_status_er(" ");setpayment_mode_er(" ");setreceipt_remarks_er(" ");settransaction_id_er(" ");

/*const $receipt_number = document.getElementById("receipt_number");
const $receipt_date = document.getElementById("receipt_date");
const $receipt_head = document.getElementById("receipt_head");
const $type = document.getElementById("type");
const $customer_name = document.getElementById("customer_name");
const $email = document.getElementById("email");
const $contact = document.getElementById("contact");
const $amount = document.getElementById("amount");
const $discount_per = document.getElementById("discount_per");
const $discount_amt = document.getElementById("discount_amt");
const $sgst_per = document.getElementById("sgst_per");
const $sgst_amt = document.getElementById("sgst_amt");
const $cgst_per = document.getElementById("cgst_per");
const $cgst_amt = document.getElementById("cgst_amt");
const $igst_per = document.getElementById("igst_per");
const $igst_amt = document.getElementById("igst_amt");
const $payable_amount = document.getElementById("payable_amount");
const $amount_paid = document.getElementById("amount_paid");
const $payment_status = document.getElementById("payment_status");
const $payment_mode = document.getElementById("payment_mode");
const $transaction_id = document.getElementById("transaction_id");
const $receipt_remarks = document.getElementById("receipt_remarks");
const $total = document.getElementById("total");
*/

const editId = sessionStorage.getItem("EditId00");
//Checking if user loggedin
if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((editId!=null)||(editId!=" "))/*&&((counterid!=null)||(counterid!=" "))*/){
 
 
  axios.post("newcrm-edit-receipt", {
   Log_id:logid,
   Token:token,
   Edit_id: editId,
   Receipt_number:document.getElementById("receipt_number").value,
   Receipt_date:document.getElementById("receipt_date").value,
   Receipt_head:document.getElementById("receipt_head").value,
   Type:document.getElementById("type").value,
   Customer_name:document.getElementById("customer_name").value,
   Email:document.getElementById("email").value,
   Contact:document.getElementById("contact").value,
   Amount:document.getElementById("amount").value,
   Discount_per:document.getElementById("discount_per").value,
   Discount_amt:document.getElementById("discount_amt").value,
   Total:document.getElementById("total").value,
   Sgst_per: document.getElementById("sgst_per").value,
   Sgst_amt: document.getElementById("sgst_amt").value,
   Cgst_per: document.getElementById("cgst_per").value,
   Cgst_amt: document.getElementById("cgst_amt").value,
   Igst_per: document.getElementById("igst_per").value,
   Igst_amt: document.getElementById("igst_amt").value,
   Payable_amount: document.getElementById("payable_amount").value,
   Amount_paid: document.getElementById("amount_paid").value,
   Payment_status: document.getElementById("payment_status").value,
   Payment_mode: document.getElementById("payment_mode").value,
   Transaction_id: document.getElementById("transaction_id").value,
   Receipt_remarks: document.getElementById("receipt_remarks").value,
   Total: document.getElementById("total").value,

 })
 .then((response) => {

  console.log(response.data);
  
  //Invalid Entries
 
  if(response.data.error==103){     seterror_msg(response.data.error_msg);  return; }

  if(response.data.error==111){     seterror_msg(response.data.error_msg); return; }
  
  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");

     window.location.replace("/");

  }

   //Validation Errors
 if(response.data.validatorerror){
  setreceipt_number_er(response.data.validatorerror.Receipt_number);
  setreceipt_date_er(response.data.validatorerror.Receipt_date);
  setreceipt_head_er(response.data.validatorerror.Receipt_head);
  settype_er(response.data.validatorerror.Type);
  setcustomer_name_er(response.data.validatorerror.Customer_name);
  setcontact_er(response.data.validatorerror.Contact);
  setemail_er(response.data.validatorerror.Email);
  setamount_er(response.data.validatorerror.Amount);
  setdiscount_per_er(response.data.validatorerror.Discount_per);
  setdiscount_amt_er(response.data.validatorerror.Discount_amt);
  setsgst_per_er(response.data.validatorerror.Sgst_per);
  setsgst_amt_er(response.data.validatorerror.Sgst_amt);
  setcgst_per_er(response.data.validatorerror.Cgst_per);
  setcgst_amt_er(response.data.validatorerror.Cgst_amt);
  setigst_per_er(response.data.validatorerror.Igst_per);
  setigst_amt_er(response.data.validatorerror.Igst_amt);
  setpayable_amount_er(response.data.validatorerror.Payable_amount);
  setamount_paid_er(response.data.validatorerror.Amount_paid);
  setpayment_status_er(response.data.validatorerror.Payment_status);
  setpayment_mode_er(response.data.validatorerror.Payment_mode);
  settransaction_id_er(response.data.validatorerror.Transaction_id);
  setreceipt_remarks_er(response.data.validatorerror.Receipt_remarks);
  settotal_er(response.data.validatorerror.Total);

  return;

}
//Invalid Entries
if(response.data.error==102){ 
  
  setreceipt_number_er(response.data.receipt_number_er);
  setreceipt_date_er(response.data.receipt_date_er);
  setreceipt_head_er(response.data.receipt_head_er);
  setcustomer_name_er(response.data.customer_name_er);
  setcontact_er(response.data.contact_er);
  setemail_er(response.data.email_er);
  setamount_er(response.data.amount_er);
  setdiscount_per_er(response.data.discount_per_er);
  setdiscount_amt_er(response.data.discount_amt_er);
  setsgst_per_er(response.data.sgst_per_er);
  setsgst_amt_er(response.data.sgst_amt_er);
  setcgst_per_er(response.data.cgst_per_er);
  setcgst_amt_er(response.data.cgst_amt_er);
  setigst_per_er(response.data.igst_per_er);
  setigst_amt_er(response.data.igst_amt_er);
  setpayable_amount_er(response.data.payable_amount_er);
  setamount_paid_er(response.data.amount_paid_er);
  setpayment_status_er(response.data.payment_status_er);
  setpayment_mode_er(response.data.payment_mode_er);
  settransaction_id_er(response.data.transaction_id_er);
  setreceipt_remarks_er(response.data.receipt_remarks_er);
  settotal_er(response.data.total_er);

 
  seterror_msg("Cannot Update Receipt !");  return; }

   

   //Transaction Entered Successfully
   if(response.data.successvar==1){   document.getElementById("edit-success-card").style.display="block";  }
   //Cannot Add Transaction
   else{  seterror_msg("Cannot Update Receipt !"); }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");


   window.location.replace("/");
 
  }
 
 }
  
 //******************* EDIT RECEIPT FUNCTION END ********************//






 //Calculator
 function calculator(){

  let $amount = parseFloat(document.getElementById("amount").value);
  let $discount_per = parseFloat(document.getElementById("discount_per").value);
  let $discount_amount = parseFloat(document.getElementById("discount_amt").value);
  let $total = parseFloat(document.getElementById("total").value);
  let $sgst_per = parseFloat(document.getElementById("sgst_per").value);
  let $sgst_amt = parseFloat(document.getElementById("sgst_amt").value);
  let $cgst_per = parseFloat(document.getElementById("cgst_per").value);
  let $cgst_amt = parseFloat(document.getElementById("cgst_amt").value);
  let $igst_per = parseFloat(document.getElementById("igst_per").value);
  let $igst_amt = parseFloat(document.getElementById("igst_amt").value);
  let $payable_amount = parseFloat(document.getElementById("payable_amount").value);

  //Calculating Values
  if($discount_per>0){
    $discount_amount = parseFloat($amount)*parseFloat($discount_per)/100;
  }
  $total = parseFloat($amount)-parseFloat($discount_amount);
 
 if($sgst_per>0){
  $sgst_amt = parseFloat($total)*parseFloat($sgst_per)/100;
}
if($cgst_per>0){
  $cgst_amt = parseFloat($total)*parseFloat($cgst_per)/100;
}
if($igst_per>0){
  $igst_amt = parseFloat($total)*parseFloat($igst_per)/100;
}
$payable_amount = parseFloat($total+$sgst_amt+$cgst_amt+$igst_amt);

//Setting Values
setdiscount_amt($discount_amount);
setsgst_amt($sgst_amt);
setcgst_amt($cgst_amt);
setigst_amt($igst_amt);
settotal($total);
setpayable_amount($payable_amount);

}




    
//******************* GET EXCEL DATA FUNCTION START  ********************//
function getexcelData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
    const $filter_receipt_number = filter_receipt_number; const $filter_customer_name = filter_customer_name; const $filter_receipt_date = filter_receipt_date; const $filter_email = filter_email; const $filter_contact = filter_contact; const $filter_payment_status = filter_payment_status; 
    const $filter_amount_paid = filter_amount_paid; const $filter_payment_mode = filter_payment_mode; const $filter_transaction_id = filter_transaction_id; const $filter_remarks = filter_remarks; const $filter_receipt_head = filter_receipt_head;
 
 axios.post("newcrm-get-receipts-list-inexcel", {
   Log_id:logid,
   Token:token,
 //  Busy_id:busyid,
 //  Counter_id:counterid,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
   Filter_val : filter_val,
   Filter_receipt_number : $filter_receipt_number,
   Filter_customer_name : $filter_customer_name,
   Filter_receipt_date : $filter_receipt_date,
   Filter_email : $filter_email,
   Filter_contact : $filter_contact,
   Filter_payment_status : $filter_payment_status,
   Filter_amount_paid : $filter_amount_paid,
   Filter_payment_mode : $filter_payment_mode,
   Filter_transaction_id : $filter_transaction_id,
   Filter_remarks : $filter_remarks,
   Filter_receipt_head : $filter_receipt_head,
   
   //Code Edits for pagination
   'page' : pageNumber


   })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");

     window.location.replace("/");
  }
 
 //Success Data Fetched
  if(response.data.successvar==1){
    //Setting Data
  const exceldata =response.data.data;
   
  // Convert JSON data to Excel worksheet
  const worksheet = XLSX.utils.json_to_sheet(exceldata);
  
  // Create a new workbook and add the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
  // Convert the workbook to a binary array
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  
  // Create a Blob from the binary data and trigger a download
  const excel_data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(excel_data, "data.xlsx");
 }
 //Cannot Fetch Data
 else{
   seterrorvar("Cannot Download Excel File !");
 }
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");


   window.location.replace("/");
 
  }
 
 }
  
 //******************* GET EXCEL DATA FUNCTION END  ********************//




return(
    <>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>BUSINESS SAMADHAN | CRM</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>


    <div class="container-scroller">

      <Sidebar />
    <div class="container-fluid page-body-wrapper">




       <Navbar />
        {/*} partial */}
        <div class="main-panel">


              
         
           
         

          {/* ADD CUSTOMER SUCCESS CARD START */}
          <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">New Customer Added Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <a href="newcrm-customers-list"><button class="mt-3 btn btn-outline-danger">Close</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* ADD CUSTOMER SUCCESS CARD END */}

                  {/* ADD CUSTOMER EDIT SUCCESS CARD START */}
        <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="edit-success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">Receipt Updated Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <a href="newcrm-receipts"> <button class="mt-3 btn btn-outline-danger">Close</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* ADD CUSTOMER EDIT SUCCESS CARD END */}
               {/* ADD CUSTOMER EDIT ERROR CARD START */}
        <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="edit-error-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-danger">Cannot Fetch Data !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <button class="mt-3 btn btn-outline-danger" onClick={()=>{ document.getElementById("edit-error-card").style.display="none"; }}>Close</button>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* ADD CUSTOMER EDIT ERROR CARD END */}

          
          

          <div class="content-wrapper pb-0">

          
        {/*} table row starts here 
        <div class="row">
             
             <div class="card stretch-card mb-3 col-md-3">
               <div class="card-body d-flex flex-wrap justify-content-between">
                 <div>
                   <h4 class="font-weight-semibold mb-1 text-black"> Products </h4>
                   <h6 class="text-muted">products listed on site</h6>
                 </div>
                 <h3 class="text-primary font-weight-bold">168</h3>
               </div>
             </div>
             <div class="card stretch-card mb-3 col-md-3">
               <div class="card-body d-flex flex-wrap justify-content-between">
                 <div>
                   <h4 class="font-weight-semibold mb-1 text-black"> Trainings </h4>
                   <h6 class="text-muted">trainings listed on site</h6>
                 </div>
                 <h3 class="text-primary font-weight-bold">689</h3>
               </div>
             </div>
             <div class="card mb-3 col-md-3">
               <div class="card-body d-flex flex-wrap justify-content-between">
                 <div>
                   <h4 class="font-weight-semibold mb-1 text-black"> Orders </h4>
                   <h6 class="text-muted">orders received on site</h6>
                 </div>
                 <h3 class="text-primary font-weight-bold">838</h3>
               </div>
             </div>
             <div class="card mb-3 col-md-3">
               <div class="card-body d-flex flex-wrap justify-content-between">
                 <div>
                   <h4 class="font-weight-semibold mb-1 text-black"> Applications </h4>
                   <h6 class="text-muted">applications received on site</h6>
                 </div>
                 <h3 class="text-primary font-weight-bold">838</h3>
               </div>
             </div>

           </div>
            table row end here */}

             {/* CREATE TEAM FORM START */}
                    <div class="row">
                        <div class="col-12 grid-margin create-form" id="create-form">
                       {/*<Newcrm_addcustomer />*/}
                    
                        </div>
                    </div>
            {/* CREATE TEAM FORM END */}

          
            <div class="page-header flex-wrap">
            <div class="header-left"></div>
              <div class="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pe-3">RECEIPTS</p>
                  </a>
                  <a class="ps-3 me-4" href="#">
                    <p class="m-0"></p>
                  </a>
                </div>
                <a href="newcrm-create-receipt"><button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text"/* onClick={()=>{ 
               const createForm = document.getElementById('create-form');
               const currentDisplay = createForm.style.display;
               createForm.style.display = currentDisplay === 'none' ? 'block' : 'none'; }} */>
                  <i class="mdi mdi-plus-circle"></i>Create New Receipt</button></a>
              
              </div>
            </div>

             {/* EDIT SALES TEAM FORM START */}
          <div class="row">
              <div class="col-12 grid-margin create-form" id="edit-form" style={{display:"none"}}>
              <div class="card" style={{textAlign:"left"}}>
                <div class="d-flex justify-content-between">
                    <div></div>
                    <div>
                    
                      <button type="button" class="btn btn-social-icon" onClick={()=>{ 
                        //Removing Sessions and Closing Edit Sales Team
                      
                       //Setting Error Variables
                       setreceipt_number_er(" ");setreceipt_date_er(" ");setreceipt_head_er(" ");settype_er(" ");setcustomer_name_er(" ");setemail_er(" ");setcontact_er(" ");setamount_er(" ");setdiscount_per_er(" ");setdiscount_amt_er(" ");
                       setsgst_per_er(" ");setsgst_amt_er(" ");setcgst_per_er(" ");setcgst_amt_er(" ");setigst_per_er(" ");setigst_amt_er(" ");settotal_er(" ");setpayable_amount_er(" ");
                       setamount_paid_er(" "); setpayment_status_er(" ");setpayment_mode_er(" ");setreceipt_remarks_er(" ");settransaction_id_er(" ");

                       setreceipt_number(" ");setreceipt_date(" ");setreceipt_head(" ");settype(" ");setcustomer_name(" ");setemail(" ");setcontact(" ");setamount(" ");setdiscount_per(" ");setdiscount_amt(" ");
                       setsgst_per(" ");setsgst_amt(" ");setcgst_per(" ");setcgst_amt(" ");setigst_per(" ");setigst_amt(" ");settotal(" ");setpayable_amount(" ");
                       setamount_paid(" "); setpayment_status(" ");setpayment_mode(" ");setreceipt_remarks(" ");settransaction_id(" ");


                       document.getElementById("edit-form").style.display="none";
                       sessionStorage.removeItem("EditId00");
                        
                         }}>
                      <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                      </button>
                      </div>
                    </div>
                  <div class="card-body">
                    <h4 class="card-title">Edit Receipt Details</h4>
                    <div class="form-sample">
                      <p class="card-description">edit customer details</p>
                      <code>{eerror_msg}</code>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Receipt Date</label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control" placeholder="RCN0001" id="receipt_date" value={receipt_date} onChange={updatereceipt_date} />
                            <code>{receipt_date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Receipt Number</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="RCN0001" id="receipt_number" value={receipt_number} onChange={updatereceipt_number} />
                            <code>{receipt_number_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Receipt Head</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="New ABC Receipt" id="receipt_head" value={receipt_head} onChange={updatereceipt_head} />
                            <code>{receipt_head_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Customer Name</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Suman Soni" id="customer_name" value={customer_name} onChange={updatecustomer_name} />
                            <code>{customer_name_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Email</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="suman@gmail.com" id="email" value={email} onChange={updateemail}/>
                              <code>{email_er}</code>
                           {/*}   <button class="btn btn-light" hidden={firsts_count>0} onClick={addfirst}>Add this as new customer ....</button>
                              <p class="text-success" style={{display:"none"}} id="cst-customer"><b>New Customer Added!</b></p> */}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Contact</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="91989898989" id="contact" value={contact} onChange={updatecontact} />
                            <code>{contact_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="type here" id="type" value={type} onChange={updatetype} />
                            <code>{type_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5000.00" id="amount" value={amount} onChange={updateamount} />
                            <code>{amount_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Discount %</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="10.00" id="discount_per" value={discount_per} onChange={updatediscount_per} />
                              <code>{discount_per_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Discount Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="500.00" id="discount_amt" value={discount_amt} onChange={updatediscount_amt} />
                              <code>{discount_amt_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Total</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="4500.0" id="total" value={total} onChange={updatetotal} />
                              <code>{total_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Transaction Id</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="TXN909988" id="transaction_id" value={transaction_id} onChange={updatetransaction_id} />
                              <code>{transaction_id_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Sgst %</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5.00"  id="sgst_per" value={sgst_per} onChange={updatesgst_per}/>
                              <code>{sgst_per_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Sgst Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="250.00" id="sgst_amt" value={sgst_amt} onChange={updatesgst_amt} />
                              <code>{sgst_amt_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Cgst %</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5.00"  id="cgst_per" value={cgst_per} onChange={updatecgst_per}/>
                              <code>{cgst_per_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Cgst Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="250.00" id="cgst_amt" value={cgst_amt} onChange={updatecgst_amt} />
                              <code>{cgst_amt_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Igst %</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5.00"  id="igst_per" value={igst_per} onChange={updateigst_per}/>
                              <code>{igst_per_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Igst Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="250.00" id="igst_amt" value={igst_amt} onChange={updateigst_amt} />
                              <code>{igst_amt_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Payable Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="6000.00"  id="payable_amount" value={payable_amount} onChange={updatepayable_amount}/>
                              <code>{payable_amount_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Amount Paid</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="6000.00" id="amount_paid" value={amount_paid} onChange={updateamount_paid} />
                              <code>{amount_paid_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Payment Status</label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="India"  id="payment_status" value={payment_status} onChange={updatepayment_status} style={{padding:"1rem"}}>
                              <option value=" ">select payment status</option>
                              <option value="paid">paid</option>
                              <option value="due">due</option>
                              <option value="partially paid">partially paid</option>
                              <option value="cancelled">cancelled</option>
                              </select>
                              <code>{payment_status_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Payment Mode</label>
                            <div class="col-sm-9">
                              <select class="form-control" pincode="420110" id="payment_mode" value={payment_mode} onChange={updatepayment_mode} style={{padding:"1rem"}}>
                              <option value=" ">select mode</option>
                              <option value="Cash">Cash</option>
                              <option value="UPI">UPI</option>
                              <option value="NEFT">NEFT</option>
                              <option value="IMPS">IMPS</option>
                              <option value="Cheque">Cheque</option>
                              <option value="Demand Draft">Demand Draft</option>
                              <option value="other">other</option>
                              </select>
                              <code>{payment_mode_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                     
                      <div class="form-group">
                        <label for="exampleTextarea1">Receipt Remarks</label>
                        <textarea  class="form-control" rows="2" placeholder="Add your Remarks here" id="receipt_remarks" value={receipt_remarks} onChange={updatereceipt_remarks} />
                        <code>{receipt_remarks_er}</code>
                      </div>
  
                        <button class="btn btn-primary" style={{fontWeight:"bold"}} onClick={editreceipt}>Edit Receipt</button>
                      
                   
                    </div>
                  </div>
                </div>
              </div>
          </div>
          {/* EDIT CUSTOMER FORM END */}

            {/* CUSTOMER DETAILS TABLE START */}
                  
             <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                {/*}    <h4 class="card-title">Customers</h4>
                    <p class="card-description">view customer details
                    </p>*/}


                             {/* FILTER SECTION START */}
                             <hr/>
                            <div id="filter-top-card" class="row col-12" style={{textAlign:"left",display:"none"}}>
                            <div class="d-flex justify-content-between">
                            <div>
                            <h4 style={{padding:'1rem'}}>Filters</h4>
                           </div>
                           <div>
                    
                           <button type="button" class="btn btn-social-icon" onClick={()=>{ document.getElementById("filter-top-card").style.display="none"; }}>
                           <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                           </button>
                           </div>
                           </div>
        
                        <div class="row">
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Receipt Number</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="121" id="filter_receipt_number" value={filter_receipt_number} onChange={updatefilter_receipt_number}  />
                              <code>{filter_receipt_number_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Customer Name</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Rakesh Sharma" value={filter_customer_name} onChange={updatefilter_customer_name}  />
                              <code>{filter_customer_name_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Email</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="rakeshsharma123@gmail.com"  value={filter_email} onChange={updatefilter_email}  />
                              <code>{filter_email_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Contact</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="9414444410"value={filter_contact} onChange={updatefilter_contact}  />
                              <code>{filter_contact_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Receipt Date</label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control"  value={filter_receipt_date} onChange={updatefilter_receipt_date}  />
                              <code>{filter_receipt_date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Payment Status</label>
                            <div class="col-sm-9">
                              <select  class="form-control" placeholder="24 A North Road" value={filter_payment_status} style={{padding:"1rem"}} onChange={updatefilter_payment_status}  >
                              <option value=" ">all</option>
                              <option value="paid">paid</option>
                              <option value="due">due</option>
                              <option value="partially paid">partially paid</option>
                              <option value="cancelled">cancelled</option>
                              </select>
                              <code>{filter_payment_status_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Amount Paid</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5000.00" value={filter_amount_paid} onChange={updatefilter_amount_paid}  />
                              <code>{filter_amount_paid_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Payment Mode</label>
                            <div class="col-sm-9">
                              <select class="form-control" value={filter_payment_mode} style={{padding:"1rem"}} onChange={updatefilter_payment_mode}  >
                              <option value=" ">all</option>
                              <option value="Cash">Cash</option>
                              <option value="UPI">UPI</option>
                              <option value="NEFT">NEFT</option>
                              <option value="IMPS">IMPS</option>
                              <option value="Cheque">Cheque</option>
                              <option value="Demand Draft">Demand Draft</option>
                              <option value="other">other</option>
                              </select>
                              <code>{filter_payment_mode_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Transaction Id</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="TXN00987" value={filter_transaction_id} onChange={updatefilter_transaction_id}  />
                              <code>{filter_transaction_id_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Receipt Head</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Service Payment" value={filter_receipt_head} onChange={updatefilter_receipt_head}  />
                              <code>{filter_receipt_head_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Receipt Remarks</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="remarks here"  value={filter_remarks} onChange={updatefilter_remarks}  />
                              <code>{filter_remarks_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                         <button class="btn btn-primary" onClick={()=>{ setfilter_val(1); getData(); }}>Apply Filters</button>
                         <button class="btn btn-danger" style={{marginLeft:"1rem"}} onClick={()=>{ setfilter_val(0); getData(); }}>Remove Filters</button>
                        </div>
                      </div>
                            <hr/>                      
                            </div>
                            
                            {/* FILTER SECTION END */}

                  <div class="col-12" style={{marginBottom:"2rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                        {/* COLUMNS MANAGEMENT DROPDOWN START */}
                       
                          <div class="dropdown">
                            <button class="btn btn-warning" onClick={()=>{ document.getElementById("filter-top-card").style.display="block"; }}><i class="mdi mdi-filter-outline"></i></button>

                          {/*}  <button class="btn btn-primary dropdown-toggle" style={{marginLeft:"1rem"}} type="button" id="dropdownMenuIconButton1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="mdi mdi-table-large"></i>
                            </button> */}    

                          
                          </div>
                          {/* COLUMNS MANAGEMENT DROPDOWN END */}

                          </div>
                          </div>


                    <div class="table-responsive"  id="reports" ref={componentRef}>
                      <table class="table table-hover">
                        <thead>
                          <tr >
                            <th  style={{fontWeight:"bold"}} id="cd_c16" hidden={cd_col16_val==1}></th> 
                            <th  style={{fontWeight:"bold"}} id="cd_c13" hidden={cd_col13_val==1}>View</th>
                            <th  style={{fontWeight:"bold"}}>Receipt Sn</th> 
                            <th  style={{fontWeight:"bold"}} id="cd_c1" hidden={cd_col1_val==1}>Receipt No.</th> 
                            <th  style={{fontWeight:"bold"}} id="cd_c2" hidden={cd_col2_val==1}>Transaction Id</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c3" hidden={cd_col3_val==1}>Receipt Date</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c4" hidden={cd_col4_val==1}>Customer Name</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c5" hidden={cd_col5_val==1}>Email</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c6" hidden={cd_col6_val==1}>Contact</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c7" hidden={cd_col7_val==1}>Payment Status</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c8" hidden={cd_col8_val==1}>Payment Mode</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c9" hidden={cd_col9_val==1}>Payable Amount</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c10" hidden={cd_col10_val==1}>Amount Paid</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c11" hidden={cd_col11_val==1}>Created At</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c12" hidden={cd_col12_val==1}>Last Updated</th>
     
                         {/*}   <th  style={{fontWeight:"bold"}} id="cd_c14" hidden={cd_col14_val==1}></th>
                            <th  style={{fontWeight:"bold"}} id="cd_c15" hidden={cd_col15_val==1}>Steam_status</th>
                            <th  style={{fontWeight:"bold"}} id="cd_c16" hidden={cd_col16_val==1}>Last Updated</th> */}
                           
                           {/*} <th  style={{fontWeight:"bold"}} id="cd_c17" hidden={cd_col17_val==1}></th> */}
                          </tr>
                        </thead>
                        <tbody>
                        {
                       data.map((curElm,ind)=>{

                         return(
                         <>
                       
                        <tr key={curElm.Cid}>
                          {/*}  <td id="cd_co1"><i class="mdi mdi-assistant text-warning" style={{fontSize:"1.4rem", cursor:"pointer"}} onClick={()=>{
                              //Setting Customer Id and Redirect to Create Leads Form
                               sessionStorage.setItem("EditId00",curElm.Cid);
                               window.location.replace("newcrm-create-lead");

                            }}></i></td> */}
                            <td id="cd_co16"  hidden={cd_col16_val==1}><i class="mdi mdi-pencil-box text-warning" style={{fontSize:"1.4rem"}} onClick={()=>{ 
                            //Setting Customer Id and Redirect to Edit
                            sessionStorage.setItem("EditId00",curElm.Receipt_sn);
                            //Set Data for the Edit Fields
                         //   document.getElementById("steam_id").value=curElm.Steam_id;//steam_id
                            document.getElementById("receipt_date").value=curElm.Receipt_date;//receipt_date
                            document.getElementById("receipt_number").value=curElm.Receipt_number;//receipt_date
                            document.getElementById("receipt_head").value=curElm.Receipt_head;//receipt_date
                            document.getElementById("customer_name").value=curElm.Customer_name;//customer_name
                            document.getElementById("email").value=curElm.Email;//email
                            document.getElementById("contact").value=curElm.Contact;//contact
                            document.getElementById("type").value=curElm.Type;//type
                            document.getElementById("amount").value=curElm.Amount;//amount
                            document.getElementById("discount_per").value=curElm.Discount_per;//discount_per
                            document.getElementById("discount_amt").value=curElm.Discount_amount;//discount_amt
                            document.getElementById("total").value=curElm.Total;//total
                            document.getElementById("transaction_id").value=curElm.Transaction_id;//transaction_id
                            document.getElementById("sgst_per").value=curElm.Sgst_per;//sgst_per
                            document.getElementById("sgst_amt").value=curElm.Sgst_amt;//sgst_amt
                            document.getElementById("cgst_per").value=curElm.Cgst_per;//cgst_per
                            document.getElementById("cgst_amt").value=curElm.Cgst_amt;//cgst_amt
                            document.getElementById("igst_per").value=curElm.Igst_per;//igst_per
                            document.getElementById("igst_amt").value=curElm.Igst_amt;//igst_amt
                            document.getElementById("payable_amount").value=curElm.Payable_amount;//payable_amount
                            document.getElementById("amount_paid").value=curElm.Amount_paid;//amount_paid
                            document.getElementById("payment_status").value=curElm.Payment_status;//payment_status
                            document.getElementById("payment_mode").value=curElm.Payment_mode;//payment_mode
                            document.getElementById("receipt_remarks").value=curElm.Receipt_remarks;//receipt_remarks

                            document.getElementById('edit-form').style.display = 'block';  
                            }}></i></td>
                            <td id="cd_co12"  hidden={cd_col12_val==1}><button class="btn btn-primary" onClick={()=>{ 
                            //Setting Customer Id and Redirect to Edit
                            sessionStorage.setItem("EditId00",curElm.Receipt_sn);
                            window.location.replace("/newcrm-view-receipt");
                             }}>View</button></td>
                            <td id="cd_co1"  hidden={cd_col1_val==1}>{curElm.Receipt_sn}</td> 
                            <td id="cd_co2"  hidden={cd_col2_val==1}>{curElm.Receipt_number}</td>
                            <td id="cd_co3"  hidden={cd_col3_val==1}>{curElm.Transaction_id}</td>
                            <td id="cd_co4"  hidden={cd_col4_val==1}>{curElm.Receipt_date}</td>
                            <td id="cd_co4"  hidden={cd_col4_val==1}>{curElm.Customer_name}</td>
                            <td id="cd_co5"  hidden={cd_col5_val==1}>{curElm.Email}</td>
                            <td id="cd_co6"  hidden={cd_col6_val==1}>{curElm.Contact}</td>
                            <td id="cd_co7"  hidden={cd_col7_val==1}>
                            <label className="badge badge-warning" hidden={(curElm.Payment_status=="paid")||(curElm.Payment_status=="due")||(curElm.Payment_status=="cancelled")}>partially paid</label>
                            <label className="badge badge-success" hidden={(curElm.Payment_status=="partially paid")||(curElm.Payment_status=="due")||(curElm.Payment_status=="cancelled")}>paid</label>
                            <label className="badge badge-danger" hidden={(curElm.Payment_status=="partially paid")||(curElm.Payment_status=="paid")||(curElm.Payment_status=="cancelled")}>due</label>
                            <label className="badge badge-danger" hidden={(curElm.Payment_status=="partially paid")||(curElm.Payment_status=="paid")||(curElm.Payment_status=="due")}>cancelled</label>
                            </td>
                            <td id="cd_co8"  hidden={cd_col8_val==1}>{curElm.Payment_mode}</td>
                            <td id="cd_co9"  hidden={cd_col9_val==1}>{curElm.Payable_amount}</td>
                            <td id="cd_co9"  hidden={cd_col9_val==1}>{curElm.Amount_paid}</td>
                            
                            <td id="cd_co11"  hidden={cd_col11_val==1}>{curElm.Date_created} ({curElm.Time_created})</td> 
                            <td id="cd_co12"  hidden={cd_col12_val==1}>{curElm.Date_updated} ({curElm.Time_updated})</td>
                          

                          
                          {/*}  <td id="cd_co17"  hidden={cd_col17_val==1}><i class="mdi mdi-delete-forever text-danger" style={{fontSize:"1.4rem"}} onClick={()=>{ 
                            //Setting Customer Id for Delete
                            sessionStorage.setItem("DEditId00",curElm.Receipt_sn);  document.getElementById('delete-card').style.display = 'block'; }}></i></td> */}
                           </tr>
                          </>
                         )
                         }
                       
                             )
                         }
                       
                         
                        </tbody>
                      </table>
                    </div> 


                    {/*}  <div class="card">
           
                  <div class="card-body px-3 text-dark">
                    <div class="d-flex justify-content-between">
                    <div>
                      <h3 class="text-muted font-13 mb-0">Message By ABC</h3>
                    </div>
                
                    
                     <label class="badge badge-warning">in process</label>
                   
                    </div>
                    <h5 class="font-weight-semibold">ABCD</h5>
                   
                       <p class="mb-0">asjijsnjs</p>
                       
                       <div class="d-flex justify-content-between mt-2">
                        
                        <p class="mb-0 mt-2 text-muted"><i class="mdi mdi-phone text-primary"></i> +97uushushs
                        <br/>
                        <i class="mdi mdi-email text-danger"></i> sksknsks
                        </p>
                        <div>
                
                    <form class="form-sample" action="#" method="POST" enctype="multipart/form-data">
                 
                        
                        <input type="hidden" value="AQN425677767104" name="Admin_access_key" readonly required />
                        <input type="hidden" value="{{ $data->Contact_id }}" name="Contact_id" readonly required />

                        <button type="submit" class="btn btn-outline-primary mt-2">mark as read</button>
                    </form>
                     </div>
                    </div>
                  </div>
                </div> 
          
         


{/*}

                
             <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Customer Details</h4>
                    <p class="card-description">customer details
                    </p>
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr >
                            <th  style={{fontWeight:"bold"}}>Sn</th>
                            <th  style={{fontWeight:"bold"}}>Customer Id</th>
                            <th  style={{fontWeight:"bold"}}>First Name</th>
                            <th  style={{fontWeight:"bold"}}>Last Name</th>
                            <th  style={{fontWeight:"bold"}}>Email</th>
                            <th  style={{fontWeight:"bold"}}>Contact</th>
                            <th  style={{fontWeight:"bold"}}>WhatsApp</th>
                            <th  style={{fontWeight:"bold"}}>Status</th>
                            <th  style={{fontWeight:"bold"}}>Source</th>
                            <th  style={{fontWeight:"bold"}}>Type</th>
                           {/*} <th  style={{fontWeight:"bold"}}>Category</th>
                            <th  style={{fontWeight:"bold"}}>Sub Category</th> 
                            <th  style={{fontWeight:"bold"}}>Last Updated</th>
                          </tr>
                        </thead>
                        <tbody>
                       
                        <tr>
                            <td>24</td>
                            <td>CA98777</td>
                            <td>Sumit</td>
                            <td>Mukherjee</td>
                            <td>sumitmukherjee@gmail.com</td>
                            <td>91 92822882822</td>
                            <td>91 8787878888</td>
                            <td>
                            <label class="badge badge-success">active</label>
                            </td>
                            <td>WhatsApp Community</td>
                            <td>Regular</td>
                            <td>21-08-2023</td>
                          </tr>
                          <tr>
                            <td>24</td>
                            <td>CA98777</td>
                            <td>Sumit</td>
                            <td>Mukherjee</td>
                            <td>sumitmukherjee@gmail.com</td>
                            <td>91 92822882822</td>
                            <td>91 8787878888</td>
                            <td>
                            <label class="badge badge-success">active</label>
                            </td>
                            <td>WhatsApp Community</td>
                            <td>Regular</td>
                            <td>21-08-2023</td>
                          </tr>
                          <tr>
                            <td>24</td>
                            <td>CA98777</td>
                            <td>Sumit</td>
                            <td>Mukherjee</td>
                            <td>sumitmukherjee@gmail.com</td>
                            <td>91 92822882822</td>
                            <td>91 8787878888</td>
                            <td>
                            <label class="badge badge-success">active</label>
                            </td>
                            <td>WhatsApp Community</td>
                            <td>Regular</td>
                            <td>21-08-2023</td>
                          </tr>
                          <tr>
                            <td>24</td>
                            <td>CA98777</td>
                            <td>Sumit</td>
                            <td>Mukherjee</td>
                            <td>sumitmukherjee@gmail.com</td>
                            <td>91 92822882822</td>
                            <td>91 8787878888</td>
                            <td>
                            <label class="badge badge-success">active</label>
                            </td>
                            <td>WhatsApp Community</td>
                            <td>Regular</td>
                            <td>21-08-2023</td>
                          </tr>
                            <tr>
                            <td>24</td>
                            <td>CA98777</td>
                            <td>Sumit</td>
                            <td>Mukherjee</td>
                            <td>sumitmukherjee@gmail.com</td>
                            <td>91 92822882822</td>
                            <td>91 8787878888</td>
                            <td>
                            <label class="badge badge-success">active</label>
                            </td>
                            <td>WhatsApp Community</td>
                            <td>Regular</td>
                            <td>21-08-2023</td>
                          </tr>
                            <tr>
                            <td>24</td>
                            <td>CA98777</td>
                            <td>Sumit</td>
                            <td>Mukherjee</td>
                            <td>sumitmukherjee@gmail.com</td>
                            <td>91 92822882822</td>
                            <td>91 8787878888</td>
                            <td>
                            <label class="badge badge-success">active</label>
                            </td>
                            <td>WhatsApp Community</td>
                            <td>Regular</td>
                            <td>21-08-2023</td>
                          </tr>
                            <tr>
                            <td>24</td>
                            <td>CA98777</td>
                            <td>Sumit</td>
                            <td>Mukherjee</td>
                            <td>sumitmukherjee@gmail.com</td>
                            <td>91 92822882822</td>
                            <td>91 8787878888</td>
                            <td>
                            <label class="badge badge-success">active</label>
                            </td>
                            <td>WhatsApp Community</td>
                            <td>Regular</td>
                            <td>21-08-2023</td>
                          </tr>
                            <tr>
                            <td>24</td>
                            <td>CA98777</td>
                            <td>Sumit</td>
                            <td>Mukherjee</td>
                            <td>sumitmukherjee@gmail.com</td>
                            <td>91 92822882822</td>
                            <td>91 8787878888</td>
                            <td>
                            <label class="badge badge-success">active</label>
                            </td>
                            <td>WhatsApp Community</td>
                            <td>Regular</td>
                            <td>21-08-2023</td>
                          </tr>
                          
                         
                        </tbody>
                      </table>
                    </div 
                  </div>
                </div>
              </div> */}












                        {/* PAGINATION SECTION START */}
                        <div>
                       <div class="col-12" style={{marginBottom:"2rem",marginTop:"1rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                       
                          <div class="dropdown">
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber-1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-left-drop-circle text-success"></i></button>
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber+1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-right-drop-circle text-success"></i></button>
                          </div>
                          </div>
                          </div>
                    </div>
                    {/* PAGINATION SECTION END */}

                    <button class="btn btn-light" onClick={handlePrint}><i class="mdi mdi-cloud-print text-dark"></i></button>
                    <button class="btn btn-light" onClick={downloadExcel}><i class="mdi mdi-file-excel text-dark"></i></button>

                   
                   
                  </div>
                </div>
              </div>
              {/* CUSTOMER DETAILS TABLE END */}


            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
         {/*} <footer class="footer">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i class="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);


//}
}
export default Newcrm_receipts;